import { CODE_MGT_ENDPOINTS, SCREENING_ENDPOINTS, } from '../../utilities/constants/api';
import Axios from '../../utilities/functions/axios';
export const getPAStatus = async () => {
    const res = await Axios.get(`${CODE_MGT_ENDPOINTS.getPAStatus}`);
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getIssuanceAgencyOptions = async () => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getIssuanceAgencyOptions('FEDSEARCHISAGN'));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getEntityTypeOptions = async (issuanceAgency) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getEntityTypeOptions('issuance-agency', issuanceAgency, 'INTERNETNO'));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getEntityType = async () => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getEntityType());
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getAddress = async (postalCode) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getAddress(postalCode));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getSSICCode = async (ssicCode) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getSSICCode(ssicCode));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getNameSuffix = async (entityNameSuffix) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getNameSuffix(entityNameSuffix));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getEntityStatus = async (statusCode, isNonACRA) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getEntityStatus(statusCode, isNonACRA));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getEntityStatusColor = async (statusCode, isNonACRA) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getEntityStatusColor(statusCode, isNonACRA));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getIssuanceAgency = async (issuanceAgency) => {
    var _a, _b, _c, _d;
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getIssuanceAgency(issuanceAgency));
    if (((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.codeList.length) > 0) {
        const issuance = (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.codeList.find((item) => item.value === issuanceAgency);
        return issuance === null || issuance === void 0 ? void 0 : issuance.description;
    }
    return '';
};
export const getIssuanceAgencyUrl = async (issuanceAgency) => {
    var _a, _b, _c, _d;
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getIssuanceAgencyUrl(issuanceAgency));
    if (((_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.result) === null || _b === void 0 ? void 0 : _b.codeList.length) > 0) {
        const issuance = (_d = (_c = res === null || res === void 0 ? void 0 : res.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.codeList.find((item) => item.value === issuanceAgency);
        return issuance === null || issuance === void 0 ? void 0 : issuance.description;
    }
    return '';
};
export const getExtractCategory = async () => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getExtractCategory());
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getAnnotationMsg = async (value) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getAnnotationMsg(value));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getEntityTypeDesc = async (value) => {
    const res = await Axios.get(CODE_MGT_ENDPOINTS.getEntityTypeDesc(value));
    return res === null || res === void 0 ? void 0 : res.data;
};
export const postTransactionDescription = async () => {
    var _a;
    const res = await Axios.post(CODE_MGT_ENDPOINTS.postTransactionDescription(), { codeTables: ['subtransaction-code'] });
    return ((_a = res === null || res === void 0 ? void 0 : res.data.result[0]) === null || _a === void 0 ? void 0 : _a.codeList) || [];
};
export const postAddressScreenStatus = async (value) => {
    const res = await Axios.post(SCREENING_ENDPOINTS.postAddressScreenStatus, {
        uen: value,
    });
    return res === null || res === void 0 ? void 0 : res.data;
};
export const getCodeManagement = async () => {
    const res = await Axios.post(CODE_MGT_ENDPOINTS.getCodeManagement(), {
        codeTables: [
            'primary-ssic-codes',
            'issuance-agency',
            'entity-status',
            'entity-type-display',
            'uen-status',
            'uen-entity-status',
            'issuance-agency-url',
            'suffix',
        ],
    });
    return res === null || res === void 0 ? void 0 : res.data;
};
